var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trace"},_vm._l((_vm.traces),function(trace){return _c(_vm.toComponent(trace.action),{key:trace.id,tag:"component",attrs:{"trace":trace,"record":_vm.record}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }